@import "~@govbr-ds/core/src/components/button/button";
@import "~@govbr-ds/core/src/components/menu/menu";

:host {
  display: block;
}

.menu-trigger {
  br-button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &::part(button) {
      border-radius: 0 !important;
    }
  }

  .trigger-label {
    flex: 1;
    text-align: center;
    font-weight: var(--font-weight-semi-bold);
  }

  .trigger-icon {
    flex-shrink: 0;
    margin-left: var(--spacing-scale-2x);
  }
}

::slotted(.drill-down-hidden),
::slotted(br-menu-list.drill-down-hidden),
::slotted(br-menu-item.drill-down-hidden) {
  display: none !important;
}

::slotted(br-menu-link) {
  margin-bottom: var(--spacing-scale-2x);

  &:last-of-type {
    margin-bottom: 0; // Remove margem do último
  }
}

.menu-back-button {
  border-bottom: 1px solid var(--color-neutral-light-20);

  .back-btn {
    display: flex;
    align-items: center;
    gap: var(--spacing-scale-2x);
    box-sizing: border-box;
    padding-block: var(--menu-item-padding, var(--menu-item-medium));
    padding-inline: var(--spacing-scale-2x);
    border: none;
    background: transparent;
    color: var(--color-primary-dark);
    font-size: var(--font-size-scale-base);
    cursor: pointer;
    width: 100%;
    justify-content: flex-start;
    transition:
      background-color 0.2s ease,
      color 0.2s ease,
      transform 0.1s ease;

    &:hover {
      background-image: linear-gradient(
        rgb(var(--interactive-rgb) / var(--hover)),
        rgb(var(--interactive-rgb) / var(--hover))
      );
    }

    &:focus-visible {
      outline: var(--focus-width) var(--focus-style) var(--focus-color);
      outline-offset: var(--focus-offset);
      border-radius: 0;
    }

    &:active {
      background: var(--color-primary-dark);
      transform: translateY(1px);
    }

    br-icon {
      font-size: var(--font-size-scale-up-01);
      color: var(--active);
    }

    .back-title {
      text-align: center;
      color: var(--active);
      font-weight: var(--font-weight-semi-bold);
    }

    .current-icon {
      margin-left: auto;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      --interactive: var(--active);

      br-icon {
        font-size: var(--font-size-scale-up-01);
      }
    }
  }
}
